import { Declaration } from 'store/declarations/declaration';
import { DeclarationExternalEntity } from 'store/declarations/enums/common/declaration-external-entity';
import { ICS2MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { getInternalType } from 'views/custom-declaration/declaration-table/DeclarationColumns';
import { getMessageTypeByDeclaration } from 'views/declarations/utils/declaration-utils';

export const getDeclarationPageHeaderTitle = (declaration: Declaration | undefined) => {
    if (!declaration) {
        return 'Uknown declaration';
    }

    const messageTypePart = getMessageTypeByDeclaration(declaration);

    // ICS2 titles
    if (declaration.declarationExternalEntity === DeclarationExternalEntity.ICS2) {
        if (messageTypePart === ICS2MessageTypes.F11) return 'Entry Maritime F11';
        if (messageTypePart === ICS2MessageTypes.F50) return 'Entry Road F50';
        const ensMessageType = declaration.ics2ENSDeclaration?.messageType;
        if (ensMessageType) return `ICS2 ENS Declaration ${ensMessageType}`;
    }

    const countryPart = getDeclarationCountryPart(declaration);
    const declarationTypePart = getInternalType(declaration);
    return `${countryPart} ${declarationTypePart} ${messageTypePart}`;
};

export const getDeclarationCountryPart = (declaration: Declaration) => {
    if (declaration.declarationExternalEntity === DeclarationExternalEntity.REVENUE) {
        return 'Irish';
    } else {
        return 'UK';
    }
};
